// extracted by mini-css-extract-plugin
export default {"colors":"b_Z_sr6pZKb44m6Wyzmv","wrapper":"qrsKwmVEYrSVweKSg4FP","dialog__item":"t4TJ0CWfUt6fYaVKwUqI"};